export const buyerRoles = ['Buyer', 'Procurement', 'Collaborator', 'Technical', 'Finance'];
export const sellerRoles = ['Seller', "Seller Team"];
export const adminRoles = ['Admin'];
export const projectManagerRoles = ['Project Manager'];
export const buyerSubRoles = ['Procurement', 'Technical', 'Finance', 'Collaborator'];
export const sellerSubRoles = ['Seller Team'];